import PropTypes from 'prop-types';

export default PropTypes.oneOf(['normal', 'small', 'large']);
